module.exports = __webpack_public_path__ + "static/media/Group69.d1e42df0.png";